import { GOOGLE_API_KEY } from "../constants";

interface Coordinates {
  lat: number;
  lng: number;
  loc: any;
}

interface AddressDetails {
  street?: string;
  block?: string;
  building?: string;
  floor?: string;
  unit?: string;
  loc: any;
  lat ?: any;
  lng ?: any;
}

export const ChangePostaltoLatLng = async (postalCode: string): Promise<Coordinates | null> => {

  let lat = 1.3548741884662894;
  let lng = 103.75231767184655;
  return { lat, lng, loc: "Singapore 650513" };
  // try {

  //   const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${postalCode}&key=${GOOGLE_API_KEY}`;
  //   const response = await fetch(url);
  //   const data = await response.json();

  //   if (data.status === "OK" && data.results.length > 0) {
  //     const { lat, lng } = data.results[0].geometry.location;
  //     return { lat, lng, loc: data.results[0].geometry.location };
  //   } else {
  //     console.error("No results found for postal code:", postalCode);
  //     return null;
  //   }
  // } catch (error) {
  //   console.error("Error fetching geolocation data:", error);
  //   return null;
  // }
};

export const ChangePostalToAddress = async (postalCode: string): Promise<{ status: number; data?: AddressDetails; message?: string }> => {
  try {
    const coord = await ChangePostaltoLatLng(postalCode);
    if (!coord) {
      return { status: 500, message: "Invalid or incorrect postal code" };
    }

    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coord.lat},${coord.lng}&key=${GOOGLE_API_KEY}`;
    const response = await fetch(url);
    const data = await response.json();

    if (data.status === "OK" && data.results.length > 0) {
      const addressComponents = data.results[0].address_components;

      const findComponent = (type: string) =>
        addressComponents.find((component: any) => component.types.includes(type))?.long_name;

      return {
        status: 200,
        data: {
          street: findComponent("route"),
          block: findComponent("premise"),
          building: findComponent("street_number"),
          floor: findComponent("floor"),
          unit: findComponent("subpremise"),
          loc: coord.loc,
          lat : coord.lat,
          lng : coord.lng
        },
      };
    } else {
      return { status: 500, message: "No address found for the given postal code" };
    }
  } catch (error) {
    console.error("Error fetching address details:", error);
    return { status: 500, message: "An error occurred while retrieving the address" };
  }
};

export const ChangeLatLngToAddress = async (lat: any, lng: any) => {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_API_KEY}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.status === "OK") {
      return data.results[0].formatted_address; // First result is usually the most relevant
    } else {
      throw new Error("No address found");
    }
  } catch (error) {
    console.error("Error fetching address:", error);
    return "Address not found";
  }
};